import React, { useState } from 'react';
import { clearRedisKeyData } from '../../../services/api/clearRedisKey';

const buttonStyle = {
  backgroundColor: 'rgba(0, 123, 255, 0)', 
  color: '#007bff', 
  padding: '6px 7px',
  border: '1px solid #007bff',
  borderRadius: '5px',
  cursor: 'pointer',
};

const confirmationButtonStyle = {
  ...buttonStyle,
  backgroundColor: 'rgba(255, 0, 0, 0)', 
  border: '1px solid #ff0000', 
  color: '#ff0000',
};

const noButtonStyle = {
  ...buttonStyle,
};

function ClearAllRedisCache() {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [message, setMessage] = useState('');

  const handleClearCache = async () => {
    setMessage('');
    if (!showConfirmation) {
      setShowConfirmation(true);
    }
  }

  const SubmitClearCache = async () => {
    if (showConfirmation) {
      setMessage('');
      try {
        const response = await clearRedisKeyData("All");
        if (response["status"] === 200) {
          setMessage(response.data)
        } else {
          setMessage(response.data.error)
        }
        setShowConfirmation(false);
      } catch (error) {
        setShowConfirmation(false);
        setMessage(error)
      }
    } else {
      setShowConfirmation(true);
      setMessage('');
    }
  };

  const NoHandleClearCache = () => {
    setShowConfirmation(false);
  }

  return (
    <div className="container my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <button style={buttonStyle} onClick={handleClearCache}>Clear Cache</button>
      {showConfirmation ? (
        <div className="confirmation-dialog">
          <p>Are you sure you want to clear the Redis cache?</p>
          <button style={confirmationButtonStyle} onClick={SubmitClearCache}>Yes</button>
          <button className='mx-1' style={noButtonStyle} onClick={NoHandleClearCache}>No</button>
        </div>
      ) : ""}
      <p>{message}</p>
    </div>
  );
}

export default ClearAllRedisCache;
